import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => (
  <footer className="bg-dark text-white p-4 mt-5">
    <div className="container">
      <p>&copy; {new Date().getFullYear()} PharmaCart. All rights reserved.</p>
      <div>
        <Link to="/about" className="text-white me-3">About Us</Link>
        <Link to="/privacy-policy" className="text-white me-3">Privacy Policy</Link>
        <Link to="/faq" className="text-white me-3">FAQ</Link>
        <Link to="/terms" className="text-white">Terms & Conditions</Link>
      </div>
    </div>
  </footer>
);

export default Footer;
